jQuery(document).ready(function ($) {
  $(".slider-hero__slick").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });

  $(".slider-icons__slick").slick({
    centerMode: true,
    centerPadding: "30px",
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          centerPadding: "60px",
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        },
      },
    ],
  });

  $(".slider-featured-product__slick").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        },
      },
    ],
  });

  $(".slider-cards__slick").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        },
      },
    ],
  });

  $("[data-modal-open-video]").on("click", function() {
    $("[data-modal-video]").fadeToggle()
  })

  $("[data-modal-close]").on("click", function() {
    $("[data-modal-video]").fadeToggle();
  })
});
